export default __webpack_public_path__ + "static/media/coming-soon-bead.8b384071.png";